module.exports = __webpack_public_path__ + "static/img/caijingshangmao-1.fc76208c.svg";